/* Alcove Studio overrides for Colors 10.1.1, loaded deferred from layout/theme.liquid (re-add after a
   theme update). 10.1 strips with-interactions from Collage product cards (sections/collage.liquid), so
   Shop Our Picks lost the hover overlay Live has. Skipped on touch, same test as colors.js isTouchDevice. */
if (!window.matchMedia('(pointer: coarse)').matches) {
  document.querySelectorAll('.content.collage .collection-products').forEach(function (el) {
    el.classList.add('with-interactions');
  });
}
